export const promotionsQueryKey = ['promotions'] as const
export const promotionOptionQueryKey = ['promotion-options'] as const
